import React from "react";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const Android12Switch = styled(Switch)(() => {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");

  return {
    width: 36,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#ffffff",
        "& + .MuiSwitch-track": {
          backgroundColor: "hsl(var(--primary))",
          opacity: 1,
        },
        "& .MuiSwitch-thumb:before": {},
      },
    },
    "& .MuiSwitch-thumb": {
      width: 16,
      height: 16,
      backgroundColor: "#ffffff",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      },
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: isDark ? "#39393D" : "#E9E9EA",
      opacity: 1,
    },
  };
});

// MSwitch component
const MSwitch = ({ checked, disabled, onClick, onChange, ...props }) => {
  return (
    <Android12Switch
      checked={checked}
      disabled={disabled}
      onClick={onClick}
      onChange={onChange}
      inputProps={{ "aria-label": "MSwitch controlled" }}
      {...props}
    />
  );
};

export default MSwitch;
